export const DATE_SEPARATOR_IN_FORM = '-';
export const SP_WIDTH = 768;
export const RESIZE_LISTENERS = ['load', 'resize', 'orientationchange'];
